import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@statsbomb/kitbag-components';

// Resolve the correct icon variant and colour for a team, matching the
// header treatment: selected team = HalfMoonLeft, opponent = HalfMoonTop.
// `context` is the AG Grid context: { selectedTeamId, selectedTeamColor,
// opponentTeamColor }.
function TeamIcon({ team, context, size }) {
  if (!team || !context) return null;
  const isSelected = team.id === context.selectedTeamId;
  return (
    <span
      aria-hidden="true"
      style={{
        color: isSelected
          ? context.selectedTeamColor
          : context.opponentTeamColor,
      }}
    >
      <Icon variant={isSelected ? 'HalfMoonLeft' : 'HalfMoonTop'} size={size} />
    </span>
  );
}

TeamIcon.propTypes = {
  size: PropTypes.oneOf(['tiny', 'small']),
  team: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  context: PropTypes.shape({
    selectedTeamId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedTeamColor: PropTypes.string,
    opponentTeamColor: PropTypes.string,
  }),
};

TeamIcon.defaultProps = {
  team: null,
  context: null,
  size: 'small',
};

export default TeamIcon;
